/* eslint-disable react/no-did-update-set-state */
import { CONSULT_ACCEPTED } from 'Constants/consults';
import { generateIncludeParams } from 'Helpers/utils';
import { func, number, objectOf } from 'prop-types';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { consultDetails } from 'Redux/modules/webChat/actions';
import { Segment } from 'semantic-ui-react';

import FeeContent from '../../FinishConsult/FeeContent/FeeContent';
import useConsultFee from '../../FinishConsult/hooks/useConsultFee';
import ContextMenuHeader from '../ContextMenuHeader';

const consultDetailsResponseParams = {
  include: generateIncludeParams({
    id: true,
    consult_fee: true,
    sub_minutes_count: true,
    patient_message_count: true,
  }),
};

const ConsultFee = props => {
  const { closeContextMenu, consultId, consult } = props;
  const {
    status: { loading: loadingConsult },
  } = useSelector(state => state.webChat.consults);
  const {
    consultFee: { data, status, estimate },
    getConsultFee,
    estFee,
  } = useConsultFee(consultId);

  const fixedFee = consult?.status === CONSULT_ACCEPTED ? estimate?.fixedFee : data.fixedFee;
  const consultFee = consult?.status !== CONSULT_ACCEPTED ? consult.consultFee : estimate;
  const isFixed = consultFee?.fixedFee !== null;

  const loading =
    consult?.status === CONSULT_ACCEPTED
      ? status.estimate === 0
      : loadingConsult === 0 || loadingConsult === -1;

  const dispatch = useDispatch();

  const getConsult = useCallback(async () => {
    await dispatch(consultDetails(consultId, consultDetailsResponseParams));
  }, [consultId, dispatch]);

  useEffect(() => {
    if (consult?.status !== CONSULT_ACCEPTED) {
      getConsult();
    } else {
      estFee();
    }
  }, [consult?.status, estFee, getConsult, getConsultFee]);
  return (
    <Segment.Group className="context-menu">
      <ContextMenuHeader title="Fee Estimation" goBack={closeContextMenu} />
      <Segment className="body consult-fee">
        <FeeContent
          isFixed={isFixed}
          consultFee={consultFee}
          // consultFee={consult?.status === 1 ? estimate : data}
          consultId={consultId}
          isReadOnly
          fixedFee={fixedFee}
          consultDiscount={data.consultDiscount}
          isLoading={loading}
          isViewMode
        />
      </Segment>
    </Segment.Group>
  );
};

ConsultFee.propTypes = {
  closeContextMenu: func.isRequired,
  consultId: number.isRequired,
  consult: objectOf({}).isRequired,
};

export default ConsultFee;
